import React from 'react';
import { Box, Theme } from '@mui/material';
import { Link } from 'react-scroll';
import { useI18nContext } from '@procore/core-react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useStyles } from './BusinessProfileNav.styles';
import AnalyticsWrappedComponent from '../Analytics/AnalyticsWrappedComponent';

interface Props {
  displayAbout: boolean;
  displayCoverageArea: boolean;
  displayLicense: boolean;
  displayMetricsCard: boolean;
}

const BusinessProfileNav = ({
  displayAbout,
  displayCoverageArea,
  displayLicense,
  displayMetricsCard,
}: Props) => {
  const I18n = useI18nContext();
  const classes = useStyles();
  const desktopView = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up('lg')
  );
  const navOffset = desktopView ? -125 : -205;

  return (
    <Box className={classes.mainDiv}>
      <ul
        data-test-id="business-profile-nav-container"
        className={classes.desktopNav}
      >
        {displayAbout && (
          <li
            data-test-id="business-profile-nav-about"
            className={classes.desktopNavItem}
          >
            <AnalyticsWrappedComponent
              componentType={Link}
              eventText="Clicked Business About"
              eventLabel="About"
              data-track-click="Business Profile Nav, Navigation, About"
              activeClass="active"
              smooth
              spy
              to="about"
              offset={navOffset}
            >
              {I18n.t(
                'pages.p.business_profile_layout.business_profile_nav.about'
              )}
            </AnalyticsWrappedComponent>
          </li>
        )}
        {displayCoverageArea && (
          <li
            data-test-id="business-profile-nav-coverage-areas"
            className={classes.desktopNavItem}
          >
            <AnalyticsWrappedComponent
              componentType={Link}
              eventText="Clicked Business Service Areas"
              eventLabel="Service Areas"
              data-track-click="Business Profile Nav, Navigation, Service Areas"
              activeClass="active"
              smooth
              spy
              to="service-areas"
              offset={navOffset}
            >
              {I18n.t(
                'pages.p.business_profile_layout.business_profile_nav.service_areas'
              )}
            </AnalyticsWrappedComponent>
          </li>
        )}
        {displayLicense && (
          <li
            data-test-id="business-profile-nav-licenses"
            className={classes.desktopNavItem}
          >
            <AnalyticsWrappedComponent
              componentType={Link}
              eventText="Clicked Business Licenses"
              eventLabel="Licenses"
              data-track-click="Business Profile Nav, Navigation, Licenses"
              activeClass="active"
              smooth
              spy
              to="licenses"
              offset={navOffset}
            >
              {I18n.t(
                'pages.p.business_profile_layout.business_profile_nav.licenses'
              )}
            </AnalyticsWrappedComponent>
          </li>
        )}
        {displayMetricsCard && (
          <li
            data-test-id="business-profile-nav-activity"
            className={classes.desktopNavItem}
          >
            <AnalyticsWrappedComponent
              componentType={Link}
              eventText="Clicked Business Procore Activity"
              eventLabel="Procore Activity"
              data-track-click="Business Profile Nav, Navigation, Procore Activity"
              activeClass="active"
              smooth
              spy
              to="procore-activity"
              offset={navOffset}
            >
              {I18n.t(
                'pages.p.business_profile_layout.business_profile_nav.procore_activity'
              )}
            </AnalyticsWrappedComponent>
          </li>
        )}
      </ul>
    </Box>
  );
};

export default BusinessProfileNav;
